import {Injectable, Injector} from "@angular/core";
import {ReportModel} from "@fedeltapointofsale/data-client";
import {DocketSelectorAuditReportData} from "./docket-selector-audit-report.data";

@Injectable()
export class DocketSelectorAuditReportModel extends ReportModel<DocketSelectorAuditReportData> {
    constructor(injector: Injector) {
        super(injector, DocketSelectorAuditReportData);
    }
}
